import React from "react";
import { Drawer, Box, Typography, IconButton, Grid, ButtonBase, Chip } from "@mui/material";
import { Close } from "@mui/icons-material";

// table_areas shape (StoreTableArea::with('store_tables.orders'), see
// POSController@getTableAreas): [{ id, name, store_tables: [{ id, name, orders: [...] }] }]
// A non-empty `orders` array means the table has a live (non-final-status)
// order already — same "occupied" signal denzo-pos's TablesTab.js uses.
export default function TableSelectSheet({ open, onClose, tableAreas, selectedTableId, onSelect }) {
  return (
    <Drawer anchor="bottom" open={open} onClose={onClose} PaperProps={{ sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: "80dvh" } }}>
      <Box sx={{ p: 2, pb: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <Typography variant="h6" fontWeight={700}>
            Select a table
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>

        {(tableAreas || []).length === 0 && (
          <Typography color="text.secondary" sx={{ py: 2 }}>
            No table areas found for this store.
          </Typography>
        )}

        {(tableAreas || []).map((area) => (
          <Box key={area.id} sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              {area.name}
            </Typography>
            <Grid container spacing={1}>
              {(area.store_tables || []).map((table) => {
                const occupied = (table.orders || []).length > 0;
                const selected = table.id === selectedTableId;
                return (
                  <Grid item xs={4} sm={3} key={table.id}>
                    <ButtonBase
                      onClick={() => onSelect({ id: table.id, name: table.name, areaName: area.name })}
                      sx={{
                        width: "100%",
                        borderRadius: 2,
                        border: "1px solid",
                        borderColor: selected ? "primary.main" : "divider",
                        bgcolor: selected ? "primary.main" : occupied ? "error.50" : "background.paper",
                        color: selected ? "primary.contrastText" : "text.primary",
                        p: 1.25,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <Typography variant="body2" fontWeight={700}>
                        {table.name}
                      </Typography>
                      {occupied && !selected && <Chip label="Occupied" size="small" color="error" sx={{ height: 18, fontSize: 10 }} />}
                    </ButtonBase>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ))}
      </Box>
    </Drawer>
  );
}
